'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithStages = undefined;
var _jsxFileName = 'src/index.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _withStages = require('./with-stages');
var _withStages2 = _interopRequireDefault(_withStages);
var _arrow = require('./arrow');
var _arrow2 = _interopRequireDefault(_arrow);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var wrapperStyles = function wrapperStyles(props) {
  var theme = props.theme;
  return {
    overflow: 'hidden',
    marginTop: '-' + theme.space_sm,
    paddingBottom: theme.space_md
  };
};
var sectionStyles = function sectionStyles(props) {
  return {
    float: 'left',
    textAlign: 'center',
    position: 'relative',
    paddingRight: props.last ? 0 : '3px',
    width: 100 / props.stagesLength + '%'
  };
};
ProgressBar.propTypes = {
  active: _propTypes.number.isRequired,
  stages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    link: _propTypes.string,
    name: _propTypes.string
  })).isRequired,
  withNames: _propTypes.bool.isRequired
};
var Wrapper = _glamorous2.default.div(wrapperStyles);
var Section = _glamorous2.default.div(sectionStyles);
function ProgressBar(props) {
  var _this = this;
  var active = props.active,
    stages = props.stages,
    withNames = props.withNames,
    rest = _objectWithoutProperties(props, ['active', 'stages', 'withNames']);
  return _react2.default.createElement(Wrapper, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  }), props.stages.map(function (stage, i) {
    var stageNumber = i + 1;
    var isActive = active === stageNumber;
    var complete = !!stage.complete;
    var first = i === 0;
    var last = i === stages.length - 1;
    return _react2.default.createElement(Section, {
      key: stage.name,
      stagesLength: stages.length,
      last: last,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46
      },
      __self: _this
    }, _react2.default.createElement(_arrow2.default, {
      active: isActive,
      complete: complete,
      to: stage.link,
      first: first,
      last: last,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47
      },
      __self: _this
    }, stageNumber, withNames && '. ' + stage.name));
  }));
}
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    withNames: (0, _reduxWindow.getWidth)(state) >= 992
  };
})(ProgressBar);
exports.WithStages = _withStages2.default;